/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurgatorySummary
 */
export interface PurgatorySummary {
    /**
     * 
     * @type {number}
     * @memberof PurgatorySummary
     */
    fileCount: number;
    /**
     * 
     * @type {number}
     * @memberof PurgatorySummary
     */
    pageCount: number;
}

export function PurgatorySummaryFromJSON(json: any): PurgatorySummary {
    return PurgatorySummaryFromJSONTyped(json, false);
}

export function PurgatorySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurgatorySummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileCount': json['fileCount'],
        'pageCount': json['pageCount'],
    };
}

export function PurgatorySummaryToJSON(value?: PurgatorySummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileCount': value.fileCount,
        'pageCount': value.pageCount,
    };
}


